import Card from 'components/Card';
import {
  AmenityRequirement,
  MeetingSpaceRequirements,
} from 'generated/graphql';

interface MeetingSpaceRequirementsCardProps {
  meetingSpace: AmenityRequirement;
  meetingSpaceRequirements?: MeetingSpaceRequirements | null;
}

const MeetingSpaceRequirementsCard = ({
  meetingSpace,
  meetingSpaceRequirements,
}: MeetingSpaceRequirementsCardProps) => {
  // Only show if meeting space is required and we have requirements data
  if (
    meetingSpace !== AmenityRequirement.Required ||
    !meetingSpaceRequirements
  ) {
    return null;
  }

  return (
    <Card className="overflow-visible">
      <h2 className="font-oswald text-2xl font-bold uppercase text-secondaryBlue">
        Meeting Space Requirements
      </h2>
      <div className="mt-6 space-y-4">
        <div>
          <p className="mb-2 text-sm font-medium text-gray-500">
            Square Footage
          </p>
          <p className="font-arimo text-base font-medium text-gray-900">
            {meetingSpaceRequirements.squareFootage}
          </p>
        </div>

        <div>
          <p className="mb-2 text-sm font-medium text-gray-500">
            A/V Requirements
          </p>
          <p className="font-arimo text-base font-medium text-gray-900">
            {meetingSpaceRequirements.avRequirements}
          </p>
        </div>

        {meetingSpaceRequirements.setupDetails && (
          <div>
            <p className="mb-2 text-sm font-medium text-gray-500">
              Setup Details
            </p>
            <p className="font-arimo text-base font-medium text-gray-900">
              {meetingSpaceRequirements.setupDetails}
            </p>
          </div>
        )}
      </div>
    </Card>
  );
};

export default MeetingSpaceRequirementsCard;
